module.exports = "/fonts/opensanslightitalic.woff";